const {
  REACT_APP_FIREBASE_API_KEY,
  REACT_APP_FIREBASE_AUTH_DOMAIN,
  REACT_APP_FIREBASE_DATABASE_URL,
  REACT_APP_FIREBASE_PROJECT_ID,
  REACT_APP_FIREBASE_STORAGE_BUCKET,
  REACT_APP_FIREBASE_MESSAGE_SENDER_ID,
  REACT_APP_FIREBASE_APP_ID,
  REACT_APP_FIREBASE_MEASUREMENT_ID,
  REACT_APP_ENV,
  REACT_APP_VERSION,
} = process.env;

console.log('REACT_APP_VERSION', REACT_APP_VERSION);

export const USER_ROLES = {
  DENTIST: 'dentist',
  DESIGNER: 'designer',
  SPECIALIST: 'specialist',
  MANUFACTURER: 'manufacturer',
};

export const FIREBASE_CONFIG = {
  apiKey: REACT_APP_FIREBASE_API_KEY,
  authDomain: REACT_APP_FIREBASE_AUTH_DOMAIN,
  storageBucket: REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: REACT_APP_FIREBASE_MESSAGE_SENDER_ID,
  appId: REACT_APP_FIREBASE_APP_ID,
  measurementId: REACT_APP_FIREBASE_MEASUREMENT_ID,
  projectId: REACT_APP_FIREBASE_PROJECT_ID,
  databaseURL: REACT_APP_FIREBASE_DATABASE_URL,
};

export const APP_ENV = REACT_APP_ENV || 'dev';

const COMMON_PROPOSAL_STATUSES = {
  approved: {
    bgColor: '#F6FFED',
    textColor: '#52C41A',
    borderColor: '#B7EB8F',
    text: 'Approved',
  },
  modificationRequested: {
    bgColor: '#F9F0FF',
    textColor: '#722ED1',
    borderColor: '#D3ADF7',
    text: 'Revision Requested',
  },
  noFurtherAction: {
    bgColor: '#dddddd80',
    textColor: '#6a6868',
    borderColor: '#555770',
    text: 'No Further Action',
  },
  expired: {
    bgColor: '#8465FC',
    textColor: '#8465FC',
    borderColor: '#8465FC',
    text: 'Expired',
  },
};

export const DESIGNER_PROPOSAL_STATUSES = {
  waitingApproval: {
    color: '#3F69FF',
    text: 'Awaiting Approval',
  },
  approved: {
    color: '#49DCB2',
    text: 'Approved',
  },
  expired: {
    color: '#8465FC',
    text: 'Expired',
  },
  modificationRequested: {
    color: '#00B1FF',
    text: 'Modification Requested',
  },
  noFurtherAction: {
    color: '#8465FC',
    text: 'No Further Action',
  },
};

export const ADMIN_PROPOSAL_STATUSES = {
  ...COMMON_PROPOSAL_STATUSES,
  waitingApproval: {
    bgColor: '#F0F5FF',
    textColor: '#2F54EB',
    borderColor: '#ADC6FF',
    text: 'Pending Approval',
  },
};

export const SPECIALIST_PROPOSAL_STATUSES = {
  ...COMMON_PROPOSAL_STATUSES,
  waitingApproval: {
    bgColor: '#F0F5FF',
    textColor: '#2F54EB',
    borderColor: '#ADC6FF',
    text: 'Pending Advice',
  },
};

export const DENTIST_PROPOSAL_STATUSES = {
  ...COMMON_PROPOSAL_STATUSES,
  waitingApproval: {
    bgColor: '#FFF2E8',
    textColor: '#FA541C',
    borderColor: '#FFBB96',
    text: 'Review Design',
  },
};

export const UK_PHONE_NUMBER_REGEX =
  /\s*(([+](\s?\d)([-\s]?\d)|0)?(\s?\d)([-\s]?\d){9}|[(](\s?\d)([-\s]?\d)+\s*[)]([-\s]?\d)+)\s*/;
export const US_PHONE_NUMBER_REGEX = /^\(?([0-9]{3})\)?[-.●]?([0-9]{3})[-.●]?([0-9]{4})$/;
export const IN_PHONE_NUMBER_REGEX = /^[6-9]{1}[0-9]{9}$/;
export const TUR_PHONE_NUMBER_REGEX =
  /\s*(([+](\s?\d)([-\s]?\d)|0)?(\s?\d)([-\s]?\d){9}|[(](\s?\d)([-\s]?\d)+\s*[)]([-\s]?\d)+)\s*/;

export const YESNO = [
  {
    label: 'Yes',
    value: 'Yes',
  },
  {
    label: 'No',
    value: 'No',
  },
];

export const LOWER_DENTAL_CENTER_LINE_OF_CHIN = [
  {
    value: 'coincident',
    label: 'Coincident',
  },
  {
    value: 'shifted_to_left',
    label: 'Shifted to left',
  },
  {
    value: 'shifted_to_right',
    label: 'Shifted to right',
  },
  {
    value: 'not_sure',
    label: 'Not Sure',
  },
];

export const OVERJET_OVERBITE_OR_ANTERIOR = [
  {
    value: 'overbite',
    label: 'Overbite',
  },
  {
    value: 'AOB',
    label: 'AOB',
  },
  {
    value: 'edge_to_edge',
    label: 'Edge to Edge',
  },
  {
    value: 'not_sure',
    label: 'Not Sure',
  },
];

export const OVERJET_INCISOR_RELATIONSHIP = [
  {
    value: 'Class I',
    label: 'Class I',
  },
  {
    value: 'Class II Division I',
    label: 'Class II Division I',
  },
  {
    value: 'Class II Division II',
    label: 'Class II Division II',
  },
  {
    value: 'Class III',
    label: 'Class III',
  },
  {
    value: 'not_sure',
    label: 'Not Sure',
  },
];

export const MOLAR_RELATIONS = [
  {
    value: 'Class I',
    label: 'Class I',
  },
  {
    value: 'Class II',
    label: 'Class II',
  },
  {
    value: 'Class III',
    label: 'Class III',
  },
  {
    value: 'not_sure',
    label: 'Not Sure',
  },
];

export const TXNOBJECTIVE_OPTIONS = [
  {
    label: 'Relief of crowding',
    value: 'Relief of crowding',
  },
  {
    label: 'Levelling',
    value: 'Levelling',
  },
  {
    label: 'Correction of Incisor relationship',
    value: 'Correction of Incisor relationship',
  },
  {
    label: 'Correction of molar relationship',
    value: 'Correction of molar relationship',
  },
  {
    label: 'Maxillary arch expansion',
    value: 'Maxillary arch expansion',
  },
  {
    label: 'Correction of open bite',
    value: 'Correction of open bite',
  },
  {
    label: 'Space closure',
    value: 'Space closure',
  },
  {
    label: 'Facilitate restorative treatment',
    value: 'Facilitate restorative treatment',
  },
];

export const DENTAL_MIDLINE_OPTIONS = [
  {
    label: 'Accept resulting midline after alignment',
    value: 'Accept resulting midline after alignment',
  },
  {
    label: 'Maintain existing (may involve IPR)',
    value: 'Maintain existing (may involve IPR)',
  },
  {
    label: 'Improve (may involve IPR)',
    value: 'Improve (may involve IPR)',
  },
];

export const INCISOR_RELATIONSHIP_OVERJET_OPTIONS = [
  {
    label: 'Accept resulting overjet after alignment',
    value: 'Accept resulting overjet after alignment',
  },
  {
    label: 'Improve overjet (may involve IPR)',
    value: 'Improve overjet (may involve IPR)',
  },
  {
    label: 'Maintain existing overjet (may involve IPR)',
    value: 'Maintain existing overjet (may involve IPR)',
  },
];

export const INCISOR_RELATIONSHIP_OVERBITE_OPTIONS = [
  {
    label: 'Accept resulting overbite after alignment',
    value: 'Accept resulting overbite after alignment',
  },
  {
    label: 'Improve overbite / open bite',
    value: 'Improve overbite / open bite',
  },
  {
    label: 'Maintain existing overbite',
    value: 'Maintain existing overbite',
  },
];

export const ARCH_COORDINATION_OPTIONS = [
  {
    label: 'Maintain',
    value: 'Maintain',
  },
  {
    label: 'Correct',
    value: 'Correct',
  },
];

export const ANTEROPOSTERIOR_RELATIONSHIP_OPTIONS = [
  {
    label: 'Maintain existing',
    value: 'Maintain existing',
  },
  {
    label: 'Improve canine relationships only',
    value: 'Improve canine relationships only',
  },
  {
    label: 'Improve molar relationships and canine relationships',
    value: 'Improve molar relationships and canine relationships',
  },
];

export const RESOLUTION_UPPER_ARCH_CROWDING = [
  {
    label: 'Anterior IPR',
    value: 'Anterior IPR',
  },
  {
    label: 'Posterior IPR',
    value: 'Posterior IPR',
  },
  {
    label: 'Arch Expansion',
    value: 'Arch Expansion',
  },
  {
    label: 'Proclination',
    value: 'Proclination',
  },
];
export const RESOLUTION_LOWER_ARCH_CROWDING = [
  {
    label: 'Anterior IPR',
    value: 'Anterior IPR',
  },
  {
    label: 'Posterior IPR',
    value: 'Posterior IPR',
  },
  {
    label: 'Arch Expansion',
    value: 'Arch Expansion',
  },
  {
    label: 'Proclination',
    value: 'Proclination',
  },
];

export const LOWER_DENTAL_CENTER_LINE_OF_FACE = [
  {
    value: 'coincident',
    label: 'Coincident',
  },
  {
    value: 'lower_to_left',
    label: 'Lower to the left of upper',
  },
  {
    value: 'lower_to_right',
    label: 'Lower to the right of upper',
  },
  {
    value: 'not_sure',
    label: 'Not Sure',
  },
];

export const UPPER_DENTAL_CENTER_LINE_OF_FACE = [
  {
    value: 'coincident',
    label: 'Coincident',
  },
  {
    value: 'shifted_to_left',
    label: 'Shifted to left',
  },
  {
    value: 'shifted_to_right',
    label: 'Shifted to right',
  },
  {
    value: 'not_sure',
    label: 'Not Sure',
  },
];

export const UPLOAD_IMAGE_SECTIONS = [
  {
    title: 'Extra-Oral orthodontic photographs',
    name: 'extraOralImages',
    key: '1',
    minItems: 4,
  },
  {
    title: 'Intra-Oral orthodontic photographs',
    name: 'intraOralImages',
    key: '2',
    minItems: 4,
  },
  {
    title: 'Radiographs',
    name: 'radioGraphImgs',
    key: '3',
    minItems: 1,
  },
];

export const ADDITIONAL_FEATURES = [
  {
    label: 'Overcorrection',
    value: 'Overcorrection',
  },
  {
    label: 'Button cut outs',
    value: 'Button cut outs',
  },
  {
    label: 'Passive aligners',
    value: 'Passive aligners',
  },
];

export const TOOTH_OPTIONS = [
  {
    label: '18 / UR8',
    value: '18/UR8',
  },
  {
    label: '17 / UR7',
    value: '17/UR7',
  },
  {
    label: '16 / UR6',
    value: '16/UR6',
  },
  {
    label: '15 / UR5',
    value: '15/UR5',
  },
  {
    label: '14 / UR4',
    value: '14/UR4',
  },
  {
    label: '13 / UR3',
    value: '13/UR3',
  },
  {
    label: '12 / UR2',
    value: '12/UR2',
  },
  {
    label: '11 / UR1',
    value: '11/UR1',
  },
  {
    label: '21 / UL1',
    value: '21/UL1',
  },
  {
    label: '22 / UL2',
    value: '22/UL2',
  },
  {
    label: '23 / UL3',
    value: '23/UL3',
  },
  {
    label: '24 / UL4',
    value: '24/UL4',
  },
  {
    label: '25 / UL5',
    value: '25/UL5',
  },
  {
    label: '26 / UL6',
    value: '26/UL6',
  },
  {
    label: '27 / UL7',
    value: '27/UL7',
  },
  {
    label: '28 / UL8',
    value: '28/UL8',
  },
  {
    label: '38 / LL8',
    value: '38/LL8',
  },
  {
    label: '37 / LL7',
    value: '37/LL7',
  },
  {
    label: '36 / LL6',
    value: '36/LL6',
  },
  {
    label: '35 / LL5',
    value: '35/LL5',
  },
  {
    label: '34 / LL4',
    value: '34/LL4',
  },
  {
    label: '33 / LL3',
    value: '33/LL3',
  },
  {
    label: '32 / LL2',
    value: '32/LL2',
  },
  {
    label: '31 / LL1',
    value: '31/LL1',
  },
  {
    label: '41 / LR1',
    value: '41/LR1',
  },
  {
    label: '42 / LR2',
    value: '42/LR2',
  },
  {
    label: '43 / LR3',
    value: '43/LR3',
  },
  {
    label: '44 / LR4',
    value: '44/LR4',
  },
  {
    label: '45 / LR5',
    value: '45/LR5',
  },
  {
    label: '46 / LR6',
    value: '46/LR6',
  },
  {
    label: '47 / LR7',
    value: '47/LR7',
  },
  {
    label: '48 / LR8',
    value: '48/LR8',
  },
];

export const casesList = [
  { label: 'Cases where not accepted and about to be auto-rejected', value: 'notAcceptedCount' },
  { label: 'Cases that have<24 hours to be completed', value: 'aboutToBeDueCount' },
  { label: 'Cases are overdue 4 day target', value: 'overdueCount' },
  { label: 'Cases need lab STL files', value: 'stlRequiredCount' },
  { label: 'Cases are currently Unassigned', value: 'notAssignedCount' },
  { label: 'Pro Cases are ready for review', value: 'pendingReviewCount' },
  { label: 'Lite cases are ready for review', value: 'pendingAdminReviewCount' },
  { label: 'Cases are ready to send to manufacturer', value: 'pendingToManufacturerCount' },
];
